import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/components/Home';
import Projets from '@/components/Projets';
import SingleProjet from '@/components/Projet';
import Page404 from '@/components/Page404';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        title: 'AAS Architecture - Accueil',
        metaTags: [
          {
            name: 'description',
            content: 'Home',
          },
          {
            property: 'og:description',
            content: 'home',
          },
        ],
      },
    },
    {
      path: '/projets',
      name: 'projets',
      component: Projets,
      meta: {
        title: 'AAS Architecture - Projets',
        metaTags: [
          {
            name: 'description',
            content: 'Projets',
          },
          {
            property: 'og:description',
            content: 'projets',
          },
        ],
      },
    },
    {
      path: '/projets/:slug',
      name: 'projet',
      component: SingleProjet,
      meta: {
        title: 'AAS Architecture - Projet',
        metaTags: [
          {
            name: 'description',
            content: 'Projet',
          },
          {
            property: 'og:description',
            content: 'projet',
          },
        ],
      },
    },
    {
      path: '*',
      name: '404',
      component: Page404,
    },
  ],
  mode: 'history',
});



// WEBPACK FOOTER //
// ./src/router/index.js